import React from 'react';

import { useDispatch } from 'react-redux';

import CustomFieldFilters from 'bundles/apex/custom_fields/filters/filters';
import { changeCustomFieldsFilterGroup } from 'bundles/research/index/store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';
import { useSelector } from 'bundles/research/index/store/hooks';

import type { Filters } from 'bundles/apex/custom_fields/filters/types';

export default function PropertyCustomFieldFilters() {
  const schemas = useSelector(state => state.static.customFields);
  const filters = useSelector(state => state.query.customFieldFilters) || {};
  const dispatch = useDispatch();

  function changeFilter(filter: Partial<Filters>) {
    dispatch(changeCustomFieldsFilterGroup(filter));
    dispatch(delayRetrieveRecords());
  }

  if (!schemas?.length) {
    return null;
  }

  return (
    <CustomFieldFilters
      changeFilter={changeFilter}
      filters={filters}
      schemas={schemas}
    />
  );
}